// extracted by mini-css-extract-plugin
module.exports = {"attr":"attr__3w8kZ","sub":"sub__wj8S8","last-sub":"last-sub__YzQaU"};